import CollapsedInfoBlock from './component'

export default CollapsedInfoBlock
